var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mas",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    fill: "#001E3C",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 5.5,
    x2: 11,
    y2: 16.5,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 11,
    x2: 16.5,
    y2: 11,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRound);
export default __webpack_public_path__ + "static/media/add-round.28a3b0c2fc19487f886bcbbf16964a42.svg";
export { ForwardRef as ReactComponent };